import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import BackToTop from './back-to-top';
const Layout = (props) => {
    return _jsxs(_Fragment, { children: [props.hero, _jsx("div", { className: "container-lg py-4", style: { 'backgroundColor': '#f8f9fa', '--bs-body-bg': '#f8f9fa' }, children: _jsxs("div", { className: "row g-4", children: [_jsx("div", { className: "col-lg-4", children: _jsx("div", { className: "property-sidebar", children: props.sidebar }) }), _jsx("div", { className: "col-lg-8", children: props.main })] }) }), _jsx(BackToTop, {})] });
};
export default Layout;
